import * as Moment from 'moment';
import 'moment/min/locales';
import { IAdHocPickupStatsDto, IMatchCapturesDto, IPickupStatsDto, Pickups } from './WorldDoomLeague';

export const FormatShortTimeString = (iso8601duration: string) => {
    if (Moment.duration(iso8601duration).hours() === 0 &&
        Moment.duration(iso8601duration).minutes() === 0 &&
        Moment.duration(iso8601duration).seconds() === 0) {
        return '-';
    } else if (Moment.duration(iso8601duration).hours() > 0) {
        return `${Moment.duration(iso8601duration).hours()}h ${Moment.duration(iso8601duration).minutes()}m ${Moment.duration(iso8601duration).seconds()}s`;
    } else if (Moment.duration(iso8601duration).hours() === 0 &&
        Moment.duration(iso8601duration).minutes() > 0) {
        return `${Moment.duration(iso8601duration).minutes()}m ${Moment.duration(iso8601duration).seconds()}s`;
    } else if (Moment.duration(iso8601duration).minutes() === 0 &&
        Moment.duration(iso8601duration).seconds() > 0) {
        return `${Moment.duration(iso8601duration).seconds()}s`;
    } else {
        return `${Moment.duration(iso8601duration).minutes()}m ${Moment.duration(iso8601duration).seconds()}s`;
    }
};

export const FormatHhMmSs = (iso8601duration: string) => {
    var days = new Intl.NumberFormat('default', { minimumIntegerDigits: 2 }).format(Moment.duration(iso8601duration).days());
    var hours = new Intl.NumberFormat('default', { minimumIntegerDigits: 2 }).format(Moment.duration(iso8601duration).hours());
    var mins = new Intl.NumberFormat('default', { minimumIntegerDigits: 2 }).format(Moment.duration(iso8601duration).minutes());
    var secs = new Intl.NumberFormat('default', { minimumIntegerDigits: 2 }).format(Moment.duration(iso8601duration).seconds());

    if (Moment.duration(iso8601duration).days() !== 0) {
        return `${days}:${hours}:${mins}:${secs}`;
    } else if (Moment.duration(iso8601duration).hours() !== 0) {
        return `${hours}:${mins}:${secs}`;
    } else if (Moment.duration(iso8601duration).minutes() !== 0) {
        return `${mins}:${secs}`;
    } else {
        return `${mins}:${secs}`;
    }
};

export const FormatMinMaxAvg = (minmaxavg?: number) => {
    if (minmaxavg === null) {
        return '-';
    } else {
        return `${new Intl.NumberFormat('default', { maximumFractionDigits: 2 }).format(minmaxavg)}`;
    }
};

export const OrdinalSuffixOf = (i: number) => {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
};

const fraction = new Intl.NumberFormat('default', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});

const formatter = new Intl.NumberFormat('default', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

export const formatdecider = (input: number) => {
    if (input % 1 == 0) {
        return fraction.format(input);
    } else {
        return formatter.format(input);
    }
};

export const pcntgformat = (input: number) => {
    return `${new Intl.NumberFormat('default', { maximumFractionDigits: 3, minimumFractionDigits: 3 }).format(input)}`;
};

export const getEnumKeyByEnumValue = <T extends { [index: string]: string }>(myEnum: T, enumValue: string): keyof T | null => {
    let keys = Object.keys(myEnum).filter(x => myEnum[x] == enumValue);
    return keys.length > 0 ? keys[0] : null;
};

export interface MatchRoundFragStatsCategories {
    category: FragWeaponCategories,
    FragWeaponCategories: string[];
};

export enum FragWeaponCategories {
    Frags = "Total Frags",
    FragsWithFlag = "Frags With Flag",
    CarrierFrags = "Carrier Frags",
    CarrierFragsWithFlag = "Carrier Frags With Flag"
};

export enum PickupStatsCategories {
    WeaponsAmmo = "Weapons & Ammo",
    HealthArmor = "Health & Armor",
    PowerUps = "Power Ups",
    SpecialItems = "Special Items"
};

export interface MatchRoundDamageStatsCategories {
    category: DamageWeaponCategories,
    DamageWeaponCategories: string[];
};

export enum DamageWeaponCategories {
    Damage = "Total Damage",
    DamageWithFlag = "Damage With Flag",
    CarrierDamage = "Carrier Damage",
    CarrierDamageWithFlag = "Carrier Damage With Flag"
};

export interface MatchRoundAccuracyStatsCategories {
    category: AccuracyWeaponCategories,
    AccuracyWeaponCategories: string[];
};

export enum AccuracyWeaponCategories {
    Accuracy = "Total Accuracy",
    AccuracyWithFlag = "Accuracy With Flag",
};

export const str2bool = (value) => {
    if (value && typeof value === "string") {
        if (value.toLowerCase() === "true") return true;
        if (value.toLowerCase() === "false") return false;
    }
    return value;
};

export const getHighestAssistTable = (captures: IMatchCapturesDto[]) => {
    var assistLength = 0;
    captures.map((s, idx) => {
        if (s.assists.length - 1 > assistLength) {
            assistLength = s.assists.length - 1
        }
    });
    return assistLength;
};

export const pickupsContainHealthArmor = (pickups: IAdHocPickupStatsDto[] | IPickupStatsDto[]): boolean => {
    return pickups.some((e) =>
        e.pickupType === Pickups.MedKit ||
        e.pickupType === Pickups.StimPack ||
        e.pickupType === Pickups.HealthBonus ||
        e.pickupType === Pickups.Berserk ||
        e.pickupType === Pickups.GreenArmor ||
        e.pickupType === Pickups.ArmorBonus)
};

export const pickupsContainWeaponsAmmo = (pickups: IAdHocPickupStatsDto[] | IPickupStatsDto[]): boolean => {
    return pickups.some((e) =>
        e.pickupType === Pickups.BackPack ||
        e.pickupType === Pickups.AmmoBox ||
        e.pickupType === Pickups.Clip ||
        e.pickupType === Pickups.Shells ||
        e.pickupType === Pickups.ShellBox ||
        e.pickupType === Pickups.Rocket ||
        e.pickupType === Pickups.RocketBox ||
        e.pickupType === Pickups.Cell ||
        e.pickupType === Pickups.CellPack ||
        e.pickupType === Pickups.Shotgun ||
        e.pickupType === Pickups.SuperShotgun ||
        e.pickupType === Pickups.Chaingun ||
        e.pickupType === Pickups.RocketLauncher ||
        e.pickupType === Pickups.PlasmaGun ||
        e.pickupType === Pickups.BFG)
};

export const pickupsContainPowerUps = (pickups: IAdHocPickupStatsDto[] | IPickupStatsDto[]): boolean => {
    return pickups.some((e) =>
        e.pickupType === Pickups.ComputerMap ||
        e.pickupType === Pickups.Goggles ||
        e.pickupType === Pickups.InvisSphere ||
        e.pickupType === Pickups.MegaSphere ||
        e.pickupType === Pickups.SoulSphere ||
        e.pickupType === Pickups.BlueArmor ||
        e.pickupType === Pickups.RadSuit ||
        e.pickupType === Pickups.InvulnSphere)
};

export const pickupsContainSpecialItem = (pickups: IAdHocPickupStatsDto[] | IPickupStatsDto[]): boolean => {
    return pickups.some(e =>
        e.pickupType === Pickups.CarePackage ||
        e.pickupType === Pickups.BlueKey ||
        e.pickupType === Pickups.BlueSkull ||
        e.pickupType === Pickups.RedKey ||
        e.pickupType === Pickups.RedSkull ||
        e.pickupType === Pickups.YellowKey ||
        e.pickupType === Pickups.YellowSkull ||
        e.pickupType === Pickups.Unknown)
};

export const pickupIsInCategory = (category: PickupStatsCategories, pickup: Pickups): boolean => {
    if (category === PickupStatsCategories.HealthArmor) {
        if (pickup === Pickups.MedKit ||
            pickup === Pickups.StimPack ||
            pickup === Pickups.HealthBonus ||
            pickup === Pickups.Berserk ||
            pickup === Pickups.GreenArmor ||
            pickup === Pickups.ArmorBonus) {
            return true;
        }
    } else if (category === PickupStatsCategories.WeaponsAmmo) {
        if (pickup === Pickups.BackPack ||
            pickup === Pickups.AmmoBox ||
            pickup === Pickups.Clip ||
            pickup === Pickups.Shells ||
            pickup === Pickups.ShellBox ||
            pickup === Pickups.Rocket ||
            pickup === Pickups.RocketBox ||
            pickup === Pickups.Cell ||
            pickup === Pickups.CellPack ||
            pickup === Pickups.Shotgun ||
            pickup === Pickups.SuperShotgun ||
            pickup === Pickups.Chaingun ||
            pickup === Pickups.RocketLauncher ||
            pickup === Pickups.PlasmaGun ||
            pickup === Pickups.BFG) {
            return true;
        }
    } else if (category === PickupStatsCategories.PowerUps) {
        if (pickup === Pickups.ComputerMap ||
            pickup === Pickups.Goggles ||
            pickup === Pickups.InvisSphere ||
            pickup === Pickups.MegaSphere ||
            pickup === Pickups.SoulSphere ||
            pickup === Pickups.BlueArmor ||
            pickup === Pickups.RadSuit ||
            pickup === Pickups.InvulnSphere) {
            return true;
        }
    } else if (category === PickupStatsCategories.SpecialItems) {
        if (pickup === Pickups.CarePackage ||
            pickup === Pickups.BlueKey ||
            pickup === Pickups.BlueSkull ||
            pickup === Pickups.RedKey ||
            pickup === Pickups.RedSkull ||
            pickup === Pickups.YellowKey ||
            pickup === Pickups.YellowSkull ||
            pickup === Pickups.Unknown) {
            return true;
        }
    }
    return false;
}